import { render, staticRenderFns } from "./VAvatar.vue?vue&type=template&id=8b5731de&scoped=true"
import script from "./VAvatar.vue?vue&type=script&lang=js"
export * from "./VAvatar.vue?vue&type=script&lang=js"
import style0 from "./VAvatar.vue?vue&type=style&index=0&id=8b5731de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5731de",
  null
  
)

export default component.exports